import { render, staticRenderFns } from "./TheLanding.vue?vue&type=template&id=fe2a6510&scoped=true"
import script from "./TheLanding.vue?vue&type=script&lang=js"
export * from "./TheLanding.vue?vue&type=script&lang=js"
import style0 from "./TheLanding.vue?vue&type=style&index=0&id=fe2a6510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2a6510",
  null
  
)

export default component.exports